// extracted by mini-css-extract-plugin
export default {"table-container":"GgOzRmI2bWvz2M9Pu9lPeQ==","lastRow":"_98wm0VGhpXBSKiTTv5ntvw==","longText":"NXRYduPEr-dNp1CqQ-cGTQ=="};